import { Job } from '@/types/Job';
import { Box, Stack, Text } from '@chakra-ui/react';
import { CaretLeft } from '@phosphor-icons/react';
import { NavigateFunction } from 'react-router-dom';

interface BreadcrumbNavigationProps {
  job: Job;
  candidateName: string;
  candidateId: string;
  onNavigate: NavigateFunction;
}

export function BreadcrumbNavigation({
  job,
  candidateName,
  candidateId,
  onNavigate
}: BreadcrumbNavigationProps) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" h="100%" gap="16px">
      <Box
        as="button"
        onClick={() => onNavigate(`/job/details/${job.job_id}?tab=candidates`)}
        cursor="pointer"
      >
        <CaretLeft size={28} color="#545454" />
      </Box>
      <Box fontSize="16px" color="neutrals.700">
        <Text
          as="span"
          cursor="pointer"
          onClick={() => onNavigate(`/job`)}
          _hover={{ textDecoration: 'underline' }}
        >
          Job Management
        </Text>
        <Text as="span" mx="4px">
          /
        </Text>
        <Text
          as="span"
          cursor="pointer"
          onClick={() => onNavigate(`/job?client_id=${job.client.client_id}`)}
          _hover={{ textDecoration: 'underline' }}
        >
          {job.client.name.length > 20 ? job.client.name.slice(0, 20) + '…' : job.client.name}
        </Text>
        <Text as="span" mx="4px">
          /
        </Text>
        <Text
          as="span"
          cursor="pointer"
          onClick={() => onNavigate(`/job/details/${job.job_id}?tab=candidates`)}
          _hover={{ textDecoration: 'underline' }}
        >
          {job.job_title.length > 20 ? job.job_title.slice(0, 20) + '…' : job.job_title}
        </Text>
        <Text as="span" mx="4px">
          /
        </Text>
        <Text
          as="b"
          cursor="pointer"
          onClick={() => onNavigate(`/job/details/${job.job_id}/candidate/${candidateId}`)}
          _hover={{ textDecoration: 'underline' }}
        >
          {candidateName.length > 15 ? candidateName.slice(0, 15) + '…' : candidateName}
        </Text>
      </Box>
    </Stack>
  );
}
